import { createActions } from 'reduxsauce';
const { Types, Creators } = createActions({
  getListCardDevice: ['userName'],
  getListCardDeviceSuccess: ['listCardDevice'],
  getListCardDeviceFail: [],
  checkUserDxcGear: ['email', 'country', 'userType'],
  checkUserDxcGearSuccess: ['isDxcGear'],
  checkUserDxcGearFail:[],
  openLoadingAcknowledge: ['isOpenLoadingAckowledge'],
  getDataTicketDetail: ['isTicket', 'params'],
  getDataTicketDetailSuccess: ['dataTicketDetail'],
  closeSideSheet: ['isOpenSideSheet'],
  getNewDeviceAssetRequests: ['userName'],
  getNewDeviceAssetRequestsSuccess: ['listNewAssetRequest'],
  loadingSideSheet: ['isLoadingSideSheet'],
  getListVirtualDesktop: ['email'],
  getListVirtualDesktopSuccess: ['listVirtual'],
  clearAllDevices: [],
  setListDeviceAvailableSuccess: ['listDeviceAvailable'],
});
export const DeviceTypes = Types;
export default Creators;
